import { ProviderOptions } from "./model";
import { HttpClient } from "@angular/common/http";
import { ClientDataSource } from "./client.data.source";


export class UrlDataSource<T = any> extends ClientDataSource<T> {
    constructor(public readonly url: string, public readonly http: HttpClient) {
        super([]);

        this.http.get<T[]>(url).toPromise().then(data => this.all = data);
    }
}
